import type { SVGProps } from "react";
const SvgPostbankLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 192.76 192.76"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M0 0h192.76v192.76H0z"
      clipRule="evenodd"
    />
    <path
      fill="#e7c63d"
      fillRule="evenodd"
      d="M11.34 73.11h170.08v46.53H11.34z"
      clipRule="evenodd"
    />
    <path
      fill="none"
      stroke="#e7c63d"
      strokeMiterlimit={2.61}
      strokeWidth={0.5}
      d="M11.34 73.11h170.08v46.53H11.34z"
    />
    <path
      fill="#217cad"
      fillRule="evenodd"
      d="M129.63 97.77a6.3 6.3 0 0 1 3.74-1.33c1.86 0 2.73.67 2.73 2.64h-1.74c-1.32 0-2.87.12-4.07.7-1.2.6-2.08 1.67-2.08 3.5 0 2.32 2.1 3.63 4.24 3.63 1.44 0 3.01-.76 3.74-2.11h.05c.02.37.02 1.18.14 1.82h2.78a58 58 0 0 1-.14-2.73c-.02-.9-.05-1.82-.05-3.06v-1.56c0-3.6-1.53-5.15-5.23-5.15-1.34 0-2.98.35-4.2.92zm1.6 5.32c0-1.88 2.1-2.12 3.5-2.12h1.37c0 .95-.14 1.83-.66 2.52a2.7 2.7 0 0 1-2.21 1.1c-1.13-.01-2-.46-2-1.5m-49.7-2.5c0 3.59 2.34 6.45 6.34 6.45 4.03 0 6.36-2.86 6.36-6.44 0-4.11-2.76-6.6-6.36-6.6-3.58 0-6.33 2.48-6.33 6.6m3.3-.38c0-1.88 1-3.74 3.04-3.74 2.07 0 3.06 1.8 3.06 3.74 0 2.1-.63 4.35-3.06 4.35-2.4 0-3.04-2.28-3.04-4.35m22.6 2.73c0 2.42 1.37 3.97 3.84 3.97.94 0 1.67-.1 2.33-.29l-.1-2.52c-.32.22-.86.34-1.43.34-1.2 0-1.48-.97-1.48-2.02v-5.69h2.8V94.4h-2.8v-3.46l-3.15 1.02v2.45h-2.33v2.32h2.33zM104 94.57c-.99-.21-1.95-.45-3.44-.45-2.47 0-4.75 1.16-4.75 3.8 0 4.4 5.48 2.77 5.48 5.17 0 1.18-1.27 1.49-2.07 1.49a7 7 0 0 1-3.1-.8l-.2 2.6c1.16.31 2.38.52 3.59.52 2.56 0 5.08-1.13 5.08-3.98 0-4.41-5.48-3.18-5.48-5.12 0-1.05 1-1.36 1.85-1.36 1.16 0 1.86.2 2.83.52zm37.7 12.05h3.16v-5.98c0-1.56.5-4.06 2.78-4.06 2.02 0 2.04 2.02 2.04 3.52v6.52h3.16v-7.7c0-2.76-1.25-4.8-4.12-4.8-1.65 0-3 .54-3.98 1.94h-.05V94.4h-2.99zm13.85 0h3.15v-5.93h.05l4.04 5.93h4l-5.08-6.76 4.52-5.45h-3.72l-3.76 4.88h-.05V88.83h-3.15zm-37.33-6.14c0-1.71.82-3.9 2.85-3.9s2.66 2.26 2.66 3.9c0 1.68-.64 3.96-2.71 3.96-2.1 0-2.8-2.23-2.8-3.96m-3.06 6.14h2.96v-1.54a4.5 4.5 0 0 0 3.63 1.83c3.64 0 5.14-3.09 5.14-6.43 0-3.37-1.38-6.36-5-6.36a4.4 4.4 0 0 0-3.67 1.92v-7.21h-3.06zm-41.5-13.95h1.14c1.7 0 3.14.67 3.14 2.59s-1.49 2.47-3.14 2.47h-1.15zm-3.3 13.95h3.29v-6.28h1.39c3.53 0 6.33-1.4 6.33-5.27 0-3.96-3.27-5-6.85-5h-4.17zM40.24 84.4 55.1 84a34 34 0 0 0-16.36 24.13H25.97c.93-7.18 6.7-19.08 14.28-23.74m21.6 9.44a17.9 17.9 0 0 0-7.95 11.8h-3.82c.66-3.93 3.1-9.03 6.73-11.7.03-.02 5.04-.1 5.04-.1"
      clipRule="evenodd"
    />
    <path
      fill="#b4282e"
      fillRule="evenodd"
      d="m50.46 90.16 8.7-.24c-7.14 3.8-10.7 11.78-11.3 16.7h-6.62c.56-4.04 3.3-11.99 9.22-16.46"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPostbankLogo;
